import httpRequest, { downloadWithResponse } from "./http";

// 国家银行假期，monthHoliday 格式：YYYY-MM
export const queryBankHolidays = function (params) {
    return httpRequest("post", "/v1/bankHoliday/query", params, false);
};

export const getDict = function (params) {
    return httpRequest("post", "/public/dict", params);
};

export const getCurrencyMetadata = function () {
    return httpRequest("get", "/public/currency/list", {}, false);
};
/**
 * VA / 收款账户列表（MP端分页）
 * 接口文档 operationId: pageVaForMp
 */
export const pageKybForMp = function (params) {
    return httpRequest("post", "/v1/kyb/pageVaForMp", params, false);
};

export const pageKybForMpV2 = function (params) {
    return httpRequest("post", "/v1/kyb/pageVaApplyForMp", params, false);
};

/**
 * 收款账户明细列表（MP端分页）
 * 接口文档 operationId: pageBusinessAccountForMp
 */
export const pageBusinessAccountForMp = function (params) {
    return httpRequest("post", "/v1/kyb/pageBusinessAccountForMp", params, false);
};

/**
 * KYB 申请记录分页
 */
export const queryKybApplyPage = function (params) {
    return httpRequest("post", "/v1/kyb/queryKybApplyPage", params, false);
};

/**
 * 根据 ID 查询 VA 详情
 */
export const queryVaById = function (params) {
    return httpRequest("post", "/v1/entity/queryVaById", { ...params }, false);
};

/**
 * VA 账号详情（支持 applyId / accountId）
 * operationId: queryVaDetail
 * @param {{ applyId?: number|string, accountId?: number|string }} params
 */
export const queryVaDetail = function (params) {
    return httpRequest("post", "/v1/entity/queryVaDetail", { ...params }, false);
};

/**
 * 查询总额度
 * /v1/merchant/queryCreditAmount
 */
export const queryCreditAmount = function (params) {
    return httpRequest("post", "/v1/merchant/queryCreditAmount", params, false);
};

// 获取开户费/管理费
export const getAccountFee = function (params) {
    return httpRequest("post", "/v1/merchant/getAccountFee", { ...params }, false);
};

export const getAllDict = function (params) {
    return httpRequest("post", "/public/dict/all", params);
};

export const getCityInfo = function (params) {
    return httpRequest("post", "/public/admin-structure", params);
};

export const getEntityList = function (params) {
    // return httpRequest('post', '/v1/merchant/entity/list', params, false)
    return httpRequest("post", "/v1/merchant/entity/listForMp", params, false);
};

export const createAccount = function (params) {
    return httpRequest("post", "/v1/merchant/entity/create", params, false);
};
export const updateEntity = function (params) {
    return httpRequest("post", "/v1/merchant/entity/update", params, false);
};

// 提交 kyc
export const saveAndUpDateEntity = function (params) {
    return httpRequest("post", "/v1/merchant/entity/submitEntity", params, false);
};

// 退出登录
export const logout = function (params) {
    return httpRequest("post", "/auth/logout", params, false);
};


export const register = function (params) {
    return httpRequest("post", "/auth/register", params, false);
};
export const registerSms = function (params) {
    return httpRequest("post", "/auth/register/code", params, false);
};
/** 重置密码发送短信验证码 */
export const resetPasswordSms = function (params) {
    return httpRequest("post", "/auth/resetPassword/code", params, false);
};
/** 重置密码 */
export const resetPassword = function (params) {
    return httpRequest("post", "/auth/resetPassword", params, false);
};
export const shopList = function (params) {
    return httpRequest("post", "/v1/shop/query", params, false);
};
export const shopListV2 = function (params) {
    return httpRequest("post", "/v1/shop/querySimple", params, false);
};

// 获取正常状态店铺列表
export const getNormalShopList = function (params) {
    return httpRequest("post", "/v1/shop/getFundInShopPage", params, false);
};
// 获取正常状态的额度店铺列表
export const getNormalShopListForQuota = function (params) {
    return httpRequest("post", "/v1/shopCredit/getShopCreditPage", params, false);
};
// 获取审核状态状态列表
export const getAuditShopList = function (params) {
    return httpRequest("post", "/v1/shop/getFundInShopForAuditPage", params, false);
};

/**
 * 批量关闭入账店铺（如电商平台 NONRU_ECOMMERCE 线路）
 * 请求体字段以后端联调为准，常见为 entityId + shopIds
 */
export const batchCloseFundInShops = function (params) {
    return httpRequest("post", "/v1/kyb/cancelChannelByNos", params, false);
};
export const getShopNumber = function (params) {
    return httpRequest("post", "/v1/shop/getShopNum", params, false);
};
export const createShop = function (params) {
    return httpRequest("post", "/v1/shop/create", params, false);
};

export const createOtherShop = function (params) {
    return httpRequest("post", "/v1/kyb/createBusiness", params, false);
};

// 新增 vinted 电商店铺
export const createBtcBusiness = function (params) {
    return httpRequest("post", "/v1/shopHold/createBtcBusiness", params, false);
};
export const getProfile = function (params) {
    return httpRequest("post", "/v1/user/profile", params, false);
};
/*export const accountInfo = function(params) {
    return httpRequest("post", "/v1/account/list", params, false);
};*/
export const balance = function (params) {
    return httpRequest("post", "/v1/account/balance", params, false);
};
export const orderQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/query", params, false);
};
export const recentlyOrderQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/master/query", params, false);
};
export const orderInQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/in/query", params, false);
};
export const orderOutQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/out/query", params, false);
};
export const orderTransferQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/transfer/query", params, false);
};
export const getRate = function (params) {
    return httpRequest("post", "/public/market/rate", params, false);
};

export const queryExchangeCurrency = function (params) {
    return httpRequest("post", "/v1/fx/queryExchangeCurrency", params, false);
};

export const rateConvert = function (params) {
    return httpRequest("post", "/v1/fx/rateConvert", params, false);
};
export const getShopDetail = function (params) {
    return httpRequest("post", "/v1/shop/get", params, false);
};
export const tradeFile = function (params) {
    return httpRequest("post", "/v1/transaction/tradeFile", params, false);
};
export const updateShop = function (params) {
    return httpRequest("post", "/v1/shop/update", params, false);
};
export const backList = function (params) {
    return httpRequest("post", "/v1/payee/account/query", params, false);
};

// 添加 infinia 收款人信息
export const addInfiniaPayeeAccount = function (params) {
    return httpRequest("post", "/v1/payee/internal/account/create", params, false);
};

export const shopPayList = function (params) {
    return httpRequest("post", "/v1/shop/list", params, false);
};

export const shopPayListV2 = function (params) {
    return httpRequest("post", "/v1/shop/getShopPage", params, false);
};

export const createPayeeAccount = function (params, isEditMode) {
    let url = '/v1/payee/account/create'
    if (isEditMode) {
        url = '/v1/payee/account/update'
    }
    return httpRequest("post", url, params, false);
};

export const deletePayeeAccount = function (params) {
    return httpRequest("post", "/v1/payee/account/delete", params, false);
};

export const payeeAttachmentCreat = function (params) {
    return httpRequest(
        "post",
        "/v1/payee/account/attachment/create",
        params,
        false
    );
};

export const createOrder = function (params) {
    return httpRequest("post", "/v1/transaction/order/create", params, false);
};

export const transferQuery = function (params) {
    return httpRequest("post", "/v1/account/serial/page", params, false);
};

// 批次查询
export const orederBatchQuery = function (params) {
    return httpRequest("post", "/v1/transaction/order/batch/query", params, false);
};

// 批次明细查询
export const orderBatchDetailPage = function (params) {
    return httpRequest("post", "/v1/transaction/order/batch/detailPage", params, false);
};



export const balanceQuery = function (params) {
    return httpRequest("post", "/v1/transaction/balance/query", params, false);
};
export const tardeSms = function (params) {
    return httpRequest("post", "/v1/transaction/sms", params, false);
};
export const tradeSms = function (params) {
    return tardeSms(params);
};
export const tradeEmail = function (params) {
    return httpRequest("post", "/v1/transaction/email", params, false);
};

export const updSubUserPwd = function (params) {
    return httpRequest("post", "/v1/subUser/updSubUserPwd", { ...params }, false);
};

// 批量付款 - 提交文件（解析）
export const uploadMultiOutFile = function (params) {
    return httpRequest("post", "/v1/transaction/order/multi/out/upload", { ...params }, false);
};

// 批量付款 - 发送邮箱验证码（有效期 5 分钟）
export const sendMultiOutEmailCode = function (params) {
    return httpRequest("post", "/v1/transaction/order/multi/out/sendEmailCode", { ...params }, false);
};

// 批量付款 - 提交批次
export const submitMultiOutBatch = function (params) {
    return httpRequest("post", "/v1/transaction/order/multi/out/submitBatch", { ...params }, false);
};

// 子账户批次审核
export const auditOrderOutBatch = function (params) {
    return httpRequest("post", "/v1/transaction/orderOut/batch/audit", { ...params }, false);
};

// 子账户批次审核 - 根据批次号查询
export const queryOrderOutBatchByBatchNo = function (params) {
    return httpRequest("post", "/v1/transaction/orderOut/batch/queryByBatchNo", { ...params }, false);
};

// 子账户批量付款 - 提交审核
export const subUserApply = function (params) {
    return httpRequest("post", "/v1/transaction/orderOut/batch/apply", { ...params }, false);
};

/**
 * 获取实体已填写信息
 * @param {*} entityId 实体id
 */
export const getEntityInfo = function (entityId) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/get", { id: entityId },
        false
    );
};

/**
 * 获取实体文件信息
 * @param {*} id 文件id或包含 fileCode/fileName 的对象
 */
export const getEntityFileInfo = function (id) {
    const params = typeof id === "object" ? id : { fileCode: id };
    return httpRequest(
        "post",
        "/v1/file/getTempAccessUrl",
        params,
        false
    );
};

// 地址信息提取
export const addressAnalyze = function (params) {
    return httpRequest(
        "post",
        "/v1/thirdparty/addressAnalyze",
        params,
        false
    );
};

// 中译英
export const translateToEnglish = function (params) {
    return httpRequest(
        "post",
        "/v1/thirdparty/translate",
        params,
        false
    );
};

/**
 * 发起OCR识别
 */
export const OCRRequest = function (params) {
    return httpRequest("post", "/v1/thirdparty/ocr", params, false, { 'Content-Type': 'multipart/form-data;' });
};
// 设置默认kyc
export const modiyfKycDefault = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/modiyfKycDefault",
        params,
        false
    );
};

/**
 * 获取平台列表
 */
export const getPlatformList = function () {
    return httpRequest(
        "post",
        "/v1/platform/list", {},
        false
    );
};


// 获取平台列表V2
export const getPlatformListV2 = function (params) {
    return httpRequest(
        "post",
        "/v1/platform/getPlatformByCode", { ...params },
        false
    );
};

// 验证交易附言
export const validateRemittanceInfo = function (params) {
    return httpRequest(
        "post",
        "/v1/op/sensitiveWord/contains", { ...params },
        false
    );
};

/**
 * 根据银行卡号查询对应总行
 * @param {*} cardNo 银行卡号
 */
export const getBankCodeByCardNo = function (cardNo) {
    return httpRequest(
        "post",
        "/v1/cardBin/getBankCode",
        { cardNo },
        false
    );
};

/**
 * 获取银行列表
 * @param {*} name 银行名称关键词
 */
export const getBankList = function (name) {
    return httpRequest(
        "post",
        "/public/op/bank", { name },
        false
    );
};

/**
 * 获取银行支行列表
 * @param {*} bankCode 所属银行编码
 * @param {*} name 支行名称关键词
 */
export const getBranchList = function (bankCode, name) {
    return httpRequest(
        "post",
        "/public/op/branch", { bankCode, name },
        false
    );
};

/**
 * 获取银行支行列表
 * @param {*} id 收款人id
 */
export const queryAttachmentFile = function (id) {
    return httpRequest(
        "post",
        "/v1/payee/account/attachment/get", { id },
        false
    );
};

/**
 * 获取银行支行列表
 * @param {*} id 收款人id
 */
export const queryPayeeAccountInfo = function (id) {
    const url = `/v1/payee/${id}`
    return httpRequest(
        "get",
        url, {},
        false
    );
};

/**
 * 收款人账户发起审核
 * @param {*} id 收款人id
 */
export const payeeAccountSubmitAudit = function (id) {
    return httpRequest(
        "post",
        "/v1/payee/account/submit", { id },
        false
    );
};

export const uploadPayeeAccountBatch = function (params) {
    return httpRequest("post", "/v1/payee/batch/upload", params, false);
};

export const submitPayeeAccountBatch = function (params) {
    return httpRequest("post", "/v1/payee/batch/submit", params, false);
};

/**
 * 查询已发布的公告列表
 * @param {*} entityId 实体id
 */
export const queryEffectiveNotice = function (entityId) {
    return httpRequest(
        "post",
        "/v1/merchant/notice/queryEffectiveNotice", { entityId },
        false
    );
};
/**
 * 发起集中管理查询可选商户列表
 * @param {*} id 收款人id
 */
export const shopManageQueryShops = function () {
    return httpRequest(
        "post",
        "/v1/shop/queryShops", {},
        false
    );
};

/**
 * 查询已发布的公告列表
 * @param {*} entityId 实体id
 * @param {*} id 公告id
 */
export const readNotice = function (entityId, id) {
    return httpRequest(
        "post",
        "/v1/merchant/notice/readNotice", { entityId, noticeId: id },
        false
    );
};

/**
 * 根据手机号查询实体
 * @param {*} mobile 手机号
 */
/*export const queryEntityByMobile = function (mobile) {
  return httpRequest(
    "post",
    "/v1/user/queryByMobile",
    { mobile },
    false
  );
};*/
/**
 * 校验实体与手机号
 * @param mobile
 * @returns {Promise<unknown>}
 */
export const validateEntityMobile = function (params) {
    return httpRequest(
        "post",
        "/v1/user/validate/entityMobile",
        params,
        false
    );
};

/**
 * 发送店铺绑定验证码
 * @param {*} mobile 手机号
 */
export const shopManageSendSms = function (mobile) {
    return httpRequest(
        "post",
        "/auth/shop/sms/send", { mobile },
        false
    );
};


/**
 * 发送店铺绑定验证码
 * @param {*} mobile 手机号
 */
export const shopManageSendSms1 = function (params) {
    return httpRequest(
        "post",
        "/v1/message/send", params,
        false
    );
};



/**
 * 发起店铺集中管理
 */
export const shopManageAddShopManage = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/addShopManage", { ...params },
        false
    );
};

/**
 * 查看集中管理店铺列表
 * @param {*} entityId 当前实体ID
 * @param {*} pageNumber 页码
 * @param {*} pageSize 每页条数
 */
export const shopManageQueryShopManagePage = function (entityId, pageNumber, pageSize) {
    return httpRequest(
        "post",
        "/v1/shop/queryShopManagePage", {
        t: {
            manageEntityId: entityId,
        },
        pageBean: {
            pageNumber,
            pageSize
        }
    },
        false
    );
};

/**
 * 取消店铺集中管理
 * @param {*} shopManageId 店铺管理ID
 */
export const shopManageUnbind = function (shopManageId) {
    return httpRequest(
        "post",
        "/v1/merchant/shop/unbind", { shopManageId },
        false
    );
};

/**
 * 查看集中管理记录
 */
export const shopManageQueryShopManageAuditPage = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/queryShopManageAuditPage", { ...params },
        false
    );
};

/**
 * 查看集中管理记录--审核同意/拒绝
 */
export const shopManageQueryShopManageAudit = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/shop/auditShopManage", { ...params },
        false
    );
};

/**
 * 根据实体ID获取用户信息
 */
export const userQueryById = function (entityId) {
    return httpRequest(
        "post",
        "/v1/user/queryById", { entityId },
        false
    );
};

/**
 * 用户中心-发送修改密码验证码
 */
export const smsSend = function (notifyType, scene) {
    return httpRequest(
        "post",
        "/v1/message/send",
        // { countryCode,mobile }, 登陆用户发送验证码不需要传手机号，只需要传使用场景和发送验证码的类型
        { notifyType, scene },
        false
    );
};

/**
 * 用户中心-密码修改
 */
export const uptPwd = function (params) {
    return httpRequest(
        "post",
        "/v1/user/uptPwd", { ...params },
        false
    );
};

/**
 * 用户中心-邮箱修改
 */
export const uptEmail = function (params) {
    return httpRequest(
        "post",
        "/v1/user/uptEmail", { ...params },
        false
    );
};

/**
 * 获取客户经理信息
 */
export const crmQuery = function (id) {
    return httpRequest(
        "post",
        "/v1/crm/query", { id },
        false
    );
};

/**
 * 换卡查询对应记录支付信息
 */
export const fundOutQuery = function (orderNo) {
    return httpRequest(
        "post",
        "/v1/transaction/order/fundOut/query", { orderNo },
        false
    );
};

/**
 * 换卡发送验证码
 */
export const transactionSms = function () {
    return httpRequest(
        "post",
        "/v1/transaction/sms", { type: 'RE_WITHDRAW_CODE' },
        false
    );
};
/**
 * 换卡发送验证码
 */
export const transactionEmail = function () {
    return httpRequest(
        "post",
        "/v1/transaction/email", { type: 'RE_WITHDRAW_CODE' },
        false
    );
};

/**
 * 换卡重新发起支付
 */
export const reFundOut = function (params) {
    return httpRequest(
        "post",
        "/v1/transaction/order/reFundOut", { ...params },
        false
    );
};


export const getAllCountry = function () {
    return httpRequest(
        "post",
        "/op/country/all", {},
        false
    );
};


// 获取所有国家新接口
export const getAllCountryNew = function (params) {
    return httpRequest(
        "post",
        "/public/op/area", { ...params },
        false
    );
};
// 获取所有国家新接口1
export const getAllCountryNewByOP = function (params) {
    return httpRequest(
        "post",
        "/public/op/country", { ...params },
        false
    );
};

// 获取所有国家新接口1
export const upLoadFile = function (formData, config) {
    return httpRequest(
        "post",
        "/v1/file/upload2", formData,
        false,
        config
    );
};


export const queryRate = function (params) {
    return httpRequest(
        "post",
        "/v1/fx/queryRate", { ...params },
        false
    );
};


// 获取过期的 kyc 信息
export const getKycDelayInfo = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/expireDetail", { ...params },
        false
    );
};


// 提交更新 kyc 证件信息
export const reSubmitEntity = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/reSubmitEntity", { ...params },
        false
    );
};

// kyc 过期通知消息
export const kycExpireNotice = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/getExpireForMessage", { ...params },
        false
    );
};

// 关闭 kyc 过期通知
export const closeNotice = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/closeNotice", { ...params },
        false
    );
};


export const orderRefundQuery = function (params) {
    return httpRequest(
        "post",
        "/v1/transaction/order/refund/query", { ...params },
        false
    );
};


// 账户余额查询
export const accountBalanceQuery = function (params) {
    return httpRequest(
        "post",
        "/v1/account/currency/balance", { ...params },
        false
    );
};


// kyc 证件是否过期
export const kycExpireNoticeByEntity = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/isExpire", { ...params },
        false
    );
};


// 昵称修改
export const modifyNickName = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/modifyNickName", { ...params },
        false
    );
};



// 获取实体信息
export const getEntityInfoByLegal = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/legal/query", { ...params },
        false
    );
};


export const exportFiles = function (url, params) {
    return httpRequest(
        "post",
        url, { ...params },
        false
    );
};

// 下载中心-查询
export const exportFilePageQuery = function (params) {
    return httpRequest(
        "post",
        "/v2/export/page", { ...params },
        false
    );
};

// 删除下载记录
export const deleteDownloadRecord = function (params) {
    return httpRequest(
        "post",
        "/v2/export/delete", { ...params },
        false
    );
};

// 下载凭证
export const downloadReceiptFunc = function (params) {
    return httpRequest(
        "post",
        "/v1/file/getVoucherByCode", { ...params },
        false
    );
};

export const downloadVoucherZipByCode = function (params) {
    return httpRequest(
        "post",
        "/v1/file/getVoucherZipByCode", { ...params },
        false
    );
};

export const downloadReportById = function (params) {
    return downloadWithResponse(
        "/v1/report/download", { ...params }
    );
};


// 获取所有业务信息列表
export const getBusinessList = function (params) {
    return httpRequest(
        "post",
        "/public/op/business", { ...params },
        false
    );
};

// 按业务类型 code 查询业务补充资料配置
export const getSupplementByCode = function (params) {
    return httpRequest(
        "post",
        "/public/op/business/getSupplementByCode",
        { code: params && params.code },
        false
    );
};


// 获取我的账号的 va 信息
export const getMyAccountVaInfo = function (params) {
    return httpRequest(
        "post",
        "/v1/entity/queryBusinessAccountByKybId", { ...params },
        false
    );
};

// 收款账户地区/银行/币种级联（VA）
export const selectChannelBank = function (params) {
    return httpRequest(
        "post",
        "/v2/channel/bank/select",
        {
            businessType: params && params.businessType,
            businessCode: params && params.businessCode,
            vaApplyMonth: params && params.vaApplyMonth
        },
        false
    );
};

// 收款账户地区/银行/币种级联
export const selectChannelBankB2c = function (params) {
    return httpRequest("get", "/v1/channel/bank/select/b2c", { ...params }, false);
};

// 额度查询
export const queryQuota = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/shopQuota/page", { ...params },
        false
    );
};

// 获取 kyb 详细信息
export const getKybDetail = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/getKybInfoById", { kybId: params && params.kybId },
        false
    );
};

// 获取 va 所需要的 kyb 信息
export const getKybDetailForVa = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/getKybInfoById", { kybId: params && params.kybId },
        false
    );
};

// 申请 VA 账户
export const createVa = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/createVa", { ...params },
        false
    );
};

// VA 补件提交
export const submitKybSupplement = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/supplement/submit", { ...params },
        false
    );
};

// 新增额度
export const addQuota = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/shopQuota/add", { ...params },
        false
    );
};

// 新增额度-单个店铺
export const addQuotaSingleByShop = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/addShopQuote", { ...params },
        false
    );
};


// 更新额度
export const updateQuota = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/shopQuota/update", { ...params },
        false
    );
};
// 更新 kyb 信息
export const updateKybInfo = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/updKybById", { ...params },
        false
    );
};



// 提交账户持有人信息
export const submitAccountHolder = function (params) {
    return httpRequest(
        "post",
        "/v1/user/addUserHold", { ...params },
        false
    );
};


// 反显账户持有人信息
export const queryAccountHolder = function (params) {
    return httpRequest(
        "post",
        "/v1/user/getUserHold", { ...params },
        false
    );
};

/**
 * 子账户管理（MP端）
 * 说明：接口路径按子账户服务约定集中维护，如联调路径差异只需调整这里。
 */

// 子账户分页查询
export const querySubAccountPage = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/query", { ...params },
        false
    );
};

// 查询当前登录子账户信息
export const querySubUserInfo = function () {
    return httpRequest(
        "post",
        "/v1/subUser/querySubUserInfo", {},
        false
    );
};

// 新增子账户
export const createSubAccount = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/addSubUser", { ...params },
        false
    );
};

// 编辑子账户
export const updateSubAccount = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/updSubUser", { ...params },
        false
    );
};

// 启用子账户
export const enableSubAccount = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/updSubUserStatus", { ...params },
        false
    );
};

// 禁用子账户
export const disableSubAccount = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/updSubUserStatus", { ...params },
        false
    );
};

// 角色枚举
export const querySubAccountRoleOptions = function (params) {
    return httpRequest(
        "post",
        "/v1/subUser/queryRole", "",
        false
        ,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
    );
};

/**
 * 店铺持有人管理（MP端）
 * 说明：此处先按前端页面需要封装，后端路径如有差异可在此统一调整
 */

// 店铺持有人分页查询（新接口）
export const queryShopHoldPage = function (params) {
    return httpRequest(
        "post",
        "/v1/shopHold/queryShopHoldPage", { ...params },
        false
    );
};

// 店铺持有人详情（新接口）
export const getShopHoldById = function (params) {
    return httpRequest(
        "post",
        "/v1/shopHold/getShopHoldById", { ...params },
        false
    );
};

// 新增店铺持有人（新接口）
export const addShopHold = function (params) {
    return httpRequest(
        "post",
        "/v1/shopHold/addShopHold", { ...params },
        false
    );
};

// 编辑店铺持有人（新接口）
export const modifyShopHold = function (params) {
    return httpRequest(
        "post",
        "/v1/shopHold/modifyShopHold", { ...params },
        false
    );
};

// 新增额度-单个订单
export const addQuotaSingleByOrder = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/addQuote", { ...params },
        false
    );
};

// 新增额度-单个订单带合同
export const addQuotaSingleByOrderWithContract = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/addSingletQuote", { ...params },
        false
    );
};


// 切换当前实体接口
export const switchEntity = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/switchEntity", { ...params },
        false
    );
};

// 获取当前最新的实体信息接口
export const getCurrentEntityInfo = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/getEntityInfo", { ...params },
        false
    );
};

// 根据 entityId 查询主体可用业务类型（用于收款页「申请VA」「绑定店铺」等入口展示）
export const queryBizTypeForEntityId = function (params) {
    return httpRequest(
        "post",
        "/v1/kyb/queryBizTypeForEntityId",
        { ...params },
        false
    );
};

export const hasApprovedB2bKybByEntityId = function () {
    return httpRequest(
        "get",
        "/v1/kyb/hasApprovedB2bKybByEntityId",
        {},
        false
    );
};

/** 查询主体业务类型，用于换汇入口/菜单显隐 */
export const getBizTypeByEntityId = function (params = {}) {
    return httpRequest(
        "post",
        "/v1/kyb/getBizTypeByEntityId",
        { ...params },
        false
    );
};


// 获取当前实体审核状态，是否可以修改第一步
export const checkEntityStatus = function (params) {
    return httpRequest(
        "post",
        "/v1/merchant/entity/checkEntityStatus", { ...params },
        false
    );
};


// 根据 entityId 查询用户是否缺失证件文件
export const queryEntityMissingFiles = function (params) {
    return httpRequest(
        "post",
        "/v1/shop/getLegalAttachForMp", { ...params },
        false
    );
};
